import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import iconVariavel from '../../../assets/images/ic_variable.svg';
import { VariableActions } from '../../../store/actions/variables';

import {
  Wrapper,
  ContainerButton,
  ContainerMenu,
  ContainerMenuColumn,
} from './styles';

const MenuVariaveisChatbot = ({
  onSelect,
  children,
  buttonRight,
  buttonBottom,
  containerTop,
  hidden,
  id,
  isTooltip = false,
  botId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { variables } = useSelector((state) => state.variables.variablesState);
  const dispatch = useDispatch();

  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const childrenRef = useRef(null);

  useEffect(() => {
    if (botId) {
      const { list } = VariableActions;
      dispatch(list({ botId }));
    }
  }, [botId]);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [id]);

  const handleKeyUpEsc = useCallback((event) => {
    if (event.keyCode === 27) {
      setIsOpen(false);
    }
  }, []);

  const handleOutsideClick = useCallback((event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target) &&
      childrenRef.current &&
      !childrenRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keyup', handleKeyUpEsc);
    window.addEventListener('click', handleOutsideClick);
    window.addEventListener('mouseup', handleOutsideClick);

    return () => {
      window.removeEventListener('keyup', handleKeyUpEsc);
      window.removeEventListener('click', handleOutsideClick);
      window.removeEventListener('mouseup', handleOutsideClick);
    };
  });

  const handleSelect = useCallback(
    (value) => {
      onSelect(value);
    },
    [onSelect]
  );

  return (
    <Wrapper hidden={hidden}>
      <div ref={childrenRef} className="wrapper__children">
        {children}
      </div>

      <ContainerButton
        isOpen={isOpen}
        isTooltip={isTooltip}
        buttonBottom={buttonBottom}
        buttonRight={buttonRight}
      >
        <button
          type="button"
          className="menu__button"
          onClick={() => setIsOpen(!isOpen)}
          ref={buttonRef}
          data-tip
          data-for={id}
          data-event="click"
        >
          <img src={iconVariavel} alt="Icon variável" />
        </button>
      </ContainerButton>
      {isTooltip ? (
        <ReactTooltip
          id={id}
          effect="solid"
          place="bottom"
          className="menu-variaveis-content"
          clickable
          globalEventOff="click"
          isCapture
          getContent={() => (
            <>
              <ContainerMenuColumn>
                <h4>Variável Global</h4>

                <ul>
                  {variables &&
                    variables.global &&
                    variables.global.map((variavel) => (
                      <li
                        key={variavel._id}
                        onClick={() =>
                          handleSelect(`${variavel.type}.${variavel.name}`)
                        }
                      >{`{${variavel.type}.${variavel.name}}`}</li>
                    ))}
                </ul>
              </ContainerMenuColumn>
              <ContainerMenuColumn>
                <h4>Variável de Usuário</h4>

                <ul>
                  {variables &&
                    variables.bot &&
                    variables.bot.map((variavel) => (
                      <li
                        key={variavel._id}
                        onClick={() => handleSelect(variavel.name)}
                      >{`{${variavel.name}}`}</li>
                    ))}
                </ul>
              </ContainerMenuColumn>
            </>
          )}
        />
      ) : (
        <ContainerMenu
          isOpen={isOpen}
          containerTop={containerTop}
          ref={menuRef}
        >
          <ContainerMenuColumn>
            <h4>Variável Global</h4>

            <ul>
              {variables &&
                variables.global &&
                variables.global.map((variavel) => (
                  <li
                    key={variavel._id}
                    onClick={() =>
                      handleSelect(`${variavel.type}.${variavel.name}`)
                    }
                  >{`{${variavel.type}.${variavel.name}}`}</li>
                ))}
            </ul>
          </ContainerMenuColumn>
          <ContainerMenuColumn>
            <h4>Variável de Usuário</h4>

            <ul>
              {variables &&
                variables.bot &&
                variables.bot.map((variavel) => (
                  <li
                    key={variavel._id}
                    onClick={() => handleSelect(variavel.name)}
                  >{`{${variavel.name}}`}</li>
                ))}
            </ul>
          </ContainerMenuColumn>
        </ContainerMenu>
      )}
    </Wrapper>
  );
};

export default MenuVariaveisChatbot;
